import { MultiString } from "../../../../library-js/i18n/MultiString";

export enum CreatorID
{
  ROKOJORI,
  BLENDER_FOUNDATION,
  INKSCAPES_CONTRIBUTORS,
  BLACK_MAGIC_DESIGN,
  KRITA_FOUNDATION
}

export class CreatorInfo
{
  name:MultiString;
  link:MultiString;
}

export class CreatorInfos 
{
  static readonly [ CreatorID.ROKOJORI ]:CreatorInfo = 
  {
    name: { en:"ROKOJORI"},
    link: { en:"::/en/about/rokojori" }
  }

  static readonly [ CreatorID.BLENDER_FOUNDATION ]:CreatorInfo = 
  {
    name: { en:"Blender Foundation"},
    link: { en:"https://www.blender.org/about/foundation/" }
  }

  static readonly [ CreatorID.INKSCAPES_CONTRIBUTORS ]:CreatorInfo = 
  {
    name: { en:"Inkscape's Contributors"},
    link: { en:"https://inkscape.org/about/" }
  }

  static readonly [ CreatorID.BLACK_MAGIC_DESIGN ]:CreatorInfo = 
  {
    name: { en:"Black Magic Design"},
    link: { en:"https://www.blackmagicdesign.com/company" }
  }


  static readonly [ CreatorID.KRITA_FOUNDATION ]:CreatorInfo = 
  {
    name: { en:"Krita Foundation"},
    link: { en:"https://krita.org/en/about/krita-foundation/" }
  }
}